/**
 * UpgradeId — string-literal union of the four upgrade kinds.
 *
 * Lives in its own file because it's referenced from both UpgradeSystem and
 * from GameScene (where the pickup-sprite render reads this id to pick a
 * label).
 * UPGRADE_CAPS is re-exported from UpgradeSystem for the HUD readout
 * (GameScene's "SHOT 3/5" string needs to know the cap per upgrade).
 */

export type UpgradeId = "MULTISHOT" | "SPREAD" | "FIRE_RATE" | "PIERCING" | "SPEED" | "SHOT_POWER";

export const UPGRADE_IDS: readonly UpgradeId[] = [
  "MULTISHOT",
  "SPREAD",
  "FIRE_RATE",
  "PIERCING",
  "SPEED",
  "SHOT_POWER",
] as const;

export const UPGRADE_LABELS: Record<UpgradeId, string> = {
  MULTISHOT: "MULTISHOT",
  SPREAD: "SPREAD",
  FIRE_RATE: "FIRE RATE",
  PIERCING: "PIERCING",
  SPEED: "SPEED",
  SHOT_POWER: "SHOT POWER",
};
